<template>
  <div class="customerManagement">
    <!-- 客户管理页面 -->
    <div class="customs">
      <Table highlight-row :columns="columns" :data="managerList" :height="managerTableHeight" @on-row-click="currentChange" style="cursor:pointer;"></Table>
      <div class="pageChange fr">
        <Page size="small" :total="managerTotal" :current="pageParams.pageNum" @on-change="changePage" show-total></Page>
      </div>
    </div>
    <div class="baseInformations">
      <!-- 基本信息 -->
      <div class="baseTop">
        <h2 style="marginLeft:5px;marginTop:5px;">{{$t('logisticsProvider.baseInformation')}}</h2>
         <Form label-position="right" :label-width="160">
            <Row>
              <!-- 客户编号 -->
              <Col span="6">
                <Form-item :label="$t('common.merchantId') + '：'">
                  <span>{{messageObj.merchantId}}</span>
                </Form-item>
              </Col>
              <!-- 公司名称 -->
              <Col span="6">
                <Form-item :label="$t('common.companyName') + '：'">
                  <span>{{messageObj.companyName}}</span>
                </Form-item>
              </Col>
              <!-- 邮箱 -->
              <Col span="6">
                <Form-item :label="$t('common.email') + '：'">
                  <span>{{messageObj.email}}</span>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <!-- 手机号码 -->
              <Col span="6">
                <Form-item :label="$t('common.mobile') + '：'">
                  <span>{{messageObj.mobile}}</span>
                </Form-item>
              </Col>
              <!-- 联系人 -->
              <Col span="6">
                <Form-item :label="$t('common.contactName') + '：'">
                  <span>{{messageObj.contactName}}</span>
                </Form-item>
              </Col>
              <!-- 电话 -->
              <Col span="6">
                <Form-item :label="$t('common.telephone') + '：'">
                  <span>{{messageObj.telephone}}</span>
                </Form-item>
              </Col>
            </Row>
        </Form>
      </div>
      <!-- 渠道信息 -->
      <div class="baseBottom">
        <h2 style="marginLeft:5px;marginTop:5px;">{{$t('logisticsProvider.channelInformation')}}</h2>
        <div class="orderTable normalTop">
          <Table highlight-row border :columns="channelColumns" :height="tableHeight" :data="channelData"></Table>
          <div class="table-page">
            <div class="table-page-right">
              <Page :total="channelTotal" @on-change="channelChangePage" show-total :page-size="channelParams.pageSize" show-elevator :current="channelParams.pageNum" show-sizer @on-page-size-change="changePageSize" placement="top" :page-size-opts="pageArray"></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin ],
  data () {
    let self = this;
    return {
      pageParamsStatus: false, // 是否重新加载客户列表数据
      channelParamsStatus: false, // 是否重新加载渠道列表数据
      pageParams: {
        endTime: '', // 结束时间
        merchantId: '', // 商户编号
        partnerId: '', // 合作伙伴编号
        startPos: 0, // 每页开始位置
        startTime: '', // 开始时间
        pageNum: 1
      },
      channelParams: {
        endTime: '', // 结束时间
        merchantId: '', // 商户编号
        partnerId: '', // 合作伙伴编号
        startPos: 0, // 每页开始位置
        startTime: '', // 开始时间
        pageSize: 10,
        pageNum: 1
      },
      customerNum: 0, // 客户数量
      columns: [ // 客户
        {
          title: self.t('logisticsProvider.wayname'),
          width: '300px',
          align: 'center',
          key: 'contactName',
          renderHeader: (h, col) => {
            return h('div', [
              h('span', self.t('logisticsProvider.wayname')),
              h('span', '（' + self.customerNum + '）')
            ]);
          }
        }
      ],
      channelColumns: [ // 渠道
        {
          title: 'NO.',
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelName'),
          key: 'shippingMethodName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelNum'),
          key: 'shippingMethodCode',
          align: 'center'
        },
        {
          title: self.t('common.status'),
          key: 'isEnabled',
          align: 'center',
          render (h, params) {
            return params.row.isEnabled === '1'
              ? h('span', {
                style: {
                  color: '#3cb034'
                }
              }, self.t('common.status1'))
              : h('span', {
                style: {
                  color: '#de2910'
                }
              }, self.t('common.status0'));
          }
        },
        {
          title: self.t('logisticsProvider.channelType'),
          key: 'logisType',
          align: 'center',
          render: (h, params) => {
            if (params.row.logisType === '1') {
              return self.t('common.logisType1');
            } else if (params.row.logisType === '2') {
              return self.t('common.logisType2');
            } else if (params.row.logisType === '3') {
              return self.t('common.logisType3');
            } else if (params.row.logisType === '4') {
              return self.t('common.logisType4');
            } else if (params.row.logisType === '5') {
              return self.t('common.logisType5');
            }
          }
        },
        {
          title: self.t('logisticsProvider.packageNum'),
          key: 'packageQuantity',
          // sortable: true
          align: 'center',
          render: (h, params) => {
            if (params.row.packageQuantity === null) {
              return '0';
            } else {
              return h('span', params.row.packageQuantity);
            }
          }
        },
        {
          title: self.t('logisticsProvider.cost'),
          key: 'packageCost',
          align: 'center',
          render: (h, params) => {
            if (params.row.packageCost === null) {
              return '0.00';
            } else {
              return h('span', params.row.packageCost);
            }
          }
        }
      ],
      channelData: [], // 渠道信息
      managerList: [], // 客户列表
      managerTotal: 0, // 客户总记录数
      channelTotal: 0, // 渠道信息总记录数
      messageObj: {} // 基本信息
    };
  },
  methods: {
    getList () { // 初始化数据
      let v = this;
      v.axios.post(api.get_managerList, v.pageParams)
        .then(res => {
          if (res.data.code === 0) {
            v.managerList = res.data.datas.list;
            v.managerTotal = res.data.datas.total;
            v.customerNum = res.data.datas.total; // 客户数量
            if (v.managerList.length) {
              v.currentChange(v.managerList[0], 0);
              v.managerList[0]._highlight = true; // 默认第一行高亮
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 基本信息数据
    getMessage (merchantId) {
      let v = this;
      v.channelParams.merchantId = merchantId;
      v.axios.post(api.get_message + '?merchantId=' + merchantId)
        .then(res => {
          if (res.data.code === 0) {
            v.messageObj = res.data.datas;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 渠道信息数据
    getChannel () {
      let v = this;
      v.axios.post(api.get_shipping, v.channelParams)
        .then(res => {
          if (res.data.code === 0) {
            v.channelData = res.data.datas.list;
            v.channelTotal = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 点击切换选中客户
    currentChange (currentRow, index) {
      let v = this;
      v.getMessage(currentRow.merchantId);
      v.channelParamsStatus = true;
    },
    // 表格分页
    channelChangePage (page, plat) {
      let v = this;
      v.channelParams.pageNum = page;
      if (plat === null || plat === 'ebay' || plat === undefined) {
        v.channelParamsStatus = true;
      }
    },
    // 切换每页条数
    changePageSize (size) {
      let v = this;
      v.channelParams.pageSize = size;
      v.channelParamsStatus = true;
    }
  },
  created () {
    let v = this;
    v.tableHeight = v.getTableHeight(452);
    v.managerTableHeight = v.getTableHeight(280);
    v.getList();
  },
  watch: {
    pageParamsStatus (n, o) { // 监听重置列表数据
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    channelParamsStatus (n, o) { // 监听重置列表数据
      let v = this;
      if (n) {
        v.getChannel();
        v.channelParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/customerManagement.vue